// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerapeutProfil_text__Oo0UI,
.TerapeutProfil_textSecond__bk5li {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  width: 40%;
}
.TerapeutProfil_textSecond__bk5li {
  margin-top: 20px;
}
.TerapeutProfil_backToContainer__r00s5 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin-top: 30px;
  width: fit-content;
}
.TerapeutProfil_backToh1__nQM0V {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  color: #5f6d7e;
}
.TerapeutProfil_ProfilePhotoBkgd__6PpMu {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  background-color: #ebe6dd;
  margin-top: 20px;
  position: relative;
}
.TerapeutProfil_ProfilePic__sJEW8 {
  border-radius: 4px;
  border: 8px solid #ffffff;
  position: absolute;
  left: 5%;
  top: 25%;
}

.TerapeutProfil_ProfilePhoto__-T-a- {
  width: 100%;
  max-width: 180px;
  min-height: 180px;
}

.TerapeutProfil_userContainer__rHzNL {
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  width: 100%;
}
.TerapeutProfil_name__E0WMk {
  font-family: "Inter";
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
}
.TerapeutProfil_btnsContainer__ivI2H {
  display: flex;
  gap: 15px;
}
.TerapeutProfil_Button__i6p88,
.TerapeutProfil_mobileButton__\\+Ue1O {
  background-color: #cb9c2d;
  width: 220px;
  max-width: 250px;
  height: 40px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  display: flex;
  color: white;
  outline: none;
  border: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.TerapeutProfil_deleteBtn__WUIvm {
  background-color: #b60303;
}

.TerapeutProfil_mobileButton__\\+Ue1O {
  display: none;
}

.TerapeutProfil_btnText__Nbkhc {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #ffffff;
}
.TerapeutProfil_infoRow__B9gc6 {
  display: flex;
  margin-bottom: 5px;
}
.TerapeutProfil_icon__6BTGa {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.TerapeutProfil_infoText__JhPYJ {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.TerapeutProfil_BioText__aXHwu {
  width: 40%;
  margin-top: 10px;
}
.TerapeutProfil_BioHeader__ycgu2 {
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
}
.TerapeutProfil_BioPartOne__8xsHb {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  margin-bottom: 20px;
}
.TerapeutProfil_terapijaContainer__CdWP6 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.TerapeutProfil_terapijaTitle__QNYxA {
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
}

.TerapeutProfil_editButton__Jmv1L {
  background-color: #f5ebd5;
}

@media screen and (max-width: 1000px) {
  .TerapeutProfil_text__Oo0UI,
  .TerapeutProfil_textSecond__bk5li,
  .TerapeutProfil_BioText__aXHwu {
    width: 50%;
  }
}

@media screen and (max-width: 775px) {
  .TerapeutProfil_text__Oo0UI,
  .TerapeutProfil_textSecond__bk5li,
  .TerapeutProfil_BioText__aXHwu {
    width: 60%;
  }
}

@media screen and (max-width: 640px) {
  .TerapeutProfil_text__Oo0UI,
  .TerapeutProfil_textSecond__bk5li,
  .TerapeutProfil_BioText__aXHwu {
    width: 70%;
  }
}

@media screen and (max-width: 500px) {
  .TerapeutProfil_Button__i6p88 {
    display: none;
  }
  .TerapeutProfil_mobileButton__\\+Ue1O {
    display: flex;
    width: 100%;
  }
  .TerapeutProfil_BioText__aXHwu {
    width: 100%;
  }
}

@media screen and (max-width: 460px) {
  .TerapeutProfil_text__Oo0UI,
  .TerapeutProfil_textSecond__bk5li {
    width: 85%;
  }
}

@media screen and (max-width: 400px) {
  .TerapeutProfil_text__Oo0UI,
  .TerapeutProfil_textSecond__bk5li {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/terapeuti/TerapeutProfil/TerapeutProfil.module.css"],"names":[],"mappings":"AAAA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;IAGE,UAAU;EACZ;AACF;;AAEA;EACE;;;IAGE,UAAU;EACZ;AACF;;AAEA;EACE;;;IAGE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;AACF","sourcesContent":[".text,\n.textSecond {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  width: 40%;\n}\n.textSecond {\n  margin-top: 20px;\n}\n.backToContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  margin-top: 30px;\n  width: fit-content;\n}\n.backToh1 {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  text-align: left;\n  color: #5f6d7e;\n}\n.ProfilePhotoBkgd {\n  width: 100%;\n  height: 200px;\n  border-radius: 10px;\n  background-color: #ebe6dd;\n  margin-top: 20px;\n  position: relative;\n}\n.ProfilePic {\n  border-radius: 4px;\n  border: 8px solid #ffffff;\n  position: absolute;\n  left: 5%;\n  top: 25%;\n}\n\n.ProfilePhoto {\n  width: 100%;\n  max-width: 180px;\n  min-height: 180px;\n}\n\n.userContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 100px;\n  width: 100%;\n}\n.name {\n  font-family: \"Inter\";\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n}\n.btnsContainer {\n  display: flex;\n  gap: 15px;\n}\n.Button,\n.mobileButton {\n  background-color: #cb9c2d;\n  width: 220px;\n  max-width: 250px;\n  height: 40px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  display: flex;\n  color: white;\n  outline: none;\n  border: none;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.deleteBtn {\n  background-color: #b60303;\n}\n\n.mobileButton {\n  display: none;\n}\n\n.btnText {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #ffffff;\n}\n.infoRow {\n  display: flex;\n  margin-bottom: 5px;\n}\n.icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n.infoText {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.BioText {\n  width: 40%;\n  margin-top: 10px;\n}\n.BioHeader {\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n}\n.BioPartOne {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  margin-bottom: 20px;\n}\n.terapijaContainer {\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n.terapijaTitle {\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n}\n\n.editButton {\n  background-color: #f5ebd5;\n}\n\n@media screen and (max-width: 1000px) {\n  .text,\n  .textSecond,\n  .BioText {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 775px) {\n  .text,\n  .textSecond,\n  .BioText {\n    width: 60%;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .text,\n  .textSecond,\n  .BioText {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .Button {\n    display: none;\n  }\n  .mobileButton {\n    display: flex;\n    width: 100%;\n  }\n  .BioText {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .text,\n  .textSecond {\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .text,\n  .textSecond {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `TerapeutProfil_text__Oo0UI`,
	"textSecond": `TerapeutProfil_textSecond__bk5li`,
	"backToContainer": `TerapeutProfil_backToContainer__r00s5`,
	"backToh1": `TerapeutProfil_backToh1__nQM0V`,
	"ProfilePhotoBkgd": `TerapeutProfil_ProfilePhotoBkgd__6PpMu`,
	"ProfilePic": `TerapeutProfil_ProfilePic__sJEW8`,
	"ProfilePhoto": `TerapeutProfil_ProfilePhoto__-T-a-`,
	"userContainer": `TerapeutProfil_userContainer__rHzNL`,
	"name": `TerapeutProfil_name__E0WMk`,
	"btnsContainer": `TerapeutProfil_btnsContainer__ivI2H`,
	"Button": `TerapeutProfil_Button__i6p88`,
	"mobileButton": `TerapeutProfil_mobileButton__+Ue1O`,
	"deleteBtn": `TerapeutProfil_deleteBtn__WUIvm`,
	"btnText": `TerapeutProfil_btnText__Nbkhc`,
	"infoRow": `TerapeutProfil_infoRow__B9gc6`,
	"icon": `TerapeutProfil_icon__6BTGa`,
	"infoText": `TerapeutProfil_infoText__JhPYJ`,
	"BioText": `TerapeutProfil_BioText__aXHwu`,
	"BioHeader": `TerapeutProfil_BioHeader__ycgu2`,
	"BioPartOne": `TerapeutProfil_BioPartOne__8xsHb`,
	"terapijaContainer": `TerapeutProfil_terapijaContainer__CdWP6`,
	"terapijaTitle": `TerapeutProfil_terapijaTitle__QNYxA`,
	"editButton": `TerapeutProfil_editButton__Jmv1L`
};
export default ___CSS_LOADER_EXPORT___;
